import ManualAnnotationRow from './ManualAnnotationRow';
import CropDropRow from './CropDropRow';
import usePresentSelector from './usePresentSelector';
import { MAIN_FIGURE_ID } from './UIConstants';
import G from './Getters';
import ColumnHeaderRow from './ColumnHeaderRow';

import { useState, createContext } from 'react';

import InvisibleRowWhichMaintainsProperColumnWidths from './InvisibleRowWhichMaintainsProperColumnWidths';



export default function ManualAnnotationGridTable({
  editableTableRef,

  editable,

  verticalImageResizeTranslation,
  tableOutlineShowing,
  setCropIdsBeingDragged,
  cropIdsBeingDragged,

  showOnly,


  editorStyle,

  figurePanelId,
  selectedCells,
  setDontUnselectCells,
  widths,
  currentWidths,
  setMouseIsDown,


}){


  let {gelBounds,rowArrangedGridData,computedWidths,panelGlobalStyle} = usePresentSelector(state =>{
    let gelBounds = G.getGelLaneSpan(state,figurePanelId)
    let rowArrangedGridData = G.getCompleteGridLayoutData(state,{figurePanelId});
    let computedWidths;
    let panelGlobalStyle = G.getFigurePanelGlobalStyle(state,{figurePanelId});


    if(!widths){
      computedWidths = G.getColumnsWidths(state,{figurePanelId})
    }
    return {
      gelBounds,
      rowArrangedGridData,
      computedWidths,
      panelGlobalStyle
    }
  })

  let rowSpacing = panelGlobalStyle?.rowSpacing || 0;

  if( !widths ){
    widths = computedWidths;
  }

  let [rows,cols] = usePresentSelector(state => G.getTableDimensions(state,figurePanelId));

  let vertResizeStyle = {};
  let y = verticalImageResizeTranslation?.y
  if( y && y > 0 ){
    vertResizeStyle.height = y;
  }else{
    vertResizeStyle.transform = 'translate(0px,'+verticalImageResizeTranslation?.y+'px)'
  }

  vertResizeStyle = {};

  return (
    <>
      <div style={{ display:'flex',
        }}>
        <table
          style={{
            tableLayout:'fixed',
            borderSpacing:'0px 0px',
            borderCollapse:'separate', 
          }}
          class={"column-to-resize " + MAIN_FIGURE_ID}
          container={"figure-panel"}
          id="figure">
          <tbody>

            {editable!==false && <tr 
              style={vertResizeStyle}> 

              <td style={{
                height:50, textAlign:'center',
                verticalAlign:'top',
              }}
                colSpan={cols+2}>
                <div class="sg-row">
                  <div class="flex-expand"/>
                  <div class="flex-expand"/>
                </div>
              </td>

            </tr>}

            
             
              <ColumnHeaderRow {...{
                figurePanelId,
                editable,
                tableOutlineShowing,
                cols,
                gelBounds
              }}/>
            

            {editable!==false && (
              <CropDropRow 
                rowSpacing={rowSpacing}
                figurePanelId={figurePanelId}
                rowIndex={-1}/>
            )}

            {rowArrangedGridData.map( (row,rowIndex) => {

              if( showOnly ){
                if( !row.some(cell => cell.data?.value?.includes?.(showOnly))){
                  return null;;
                }
              }


              return <ManualAnnotationRow
                {...{
                  editableTableRef,
                  rowSpacing, 
                  editable,
                  verticalImageResizeTranslation,
                  figurePanelId,
                  row,
                  rowIndex,
                  setDontUnselectCells,
                  tableOutlineShowing,
                  widths,

                  editorStyle,
                  //getCellWidth,
                  currentWidths,
                  numRows:rowArrangedGridData.length,
                }}/>
            })}


            <InvisibleRowWhichMaintainsProperColumnWidths {
              ...{ 
                editable,
                widths:(currentWidths||widths) 
            }}/>



          </tbody>
        </table> 
      </div>
    </>
  )

}
